import { gql } from "lib/apolloClient";
import { organizationFragment } from "modules/CommonFragments";

export const getOrganizationBasicDetailsQuery = gql`
  query getOrganizationBasicDetails($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        ...organizationItem
        region
      }
    }
  }
  ${organizationFragment.organizationBasicDetails}
`;

export const getOrganizationCurriculumProgramsTypesQuery = gql`
  query getOrganizationCurriculumPrograms(
    $organizationId: ID!
    $curriculumProgramIds: [ID!]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        name
        curriculumPrograms(curriculumIds: $curriculumProgramIds) {
          id
          type
          label
          acronym
        }
      }
    }
  }
`;

export const getTeacherFeedQuery = gql`
  query getTeacherFeed(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        staff(
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          edges {
            node {
              id
              ... on Staff {
                id
                profileImage
                firstName
                lastName
                email
                isArchived
              }
            }
          }
        }
      }
    }
  }
`;

export const getRnPLevelsFeedQuery = gql`
  query getRnPLevelsFeed($id: ID!, $rnpViewFilters: RnpViewFilters!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        rnpView(filters: $rnpViewFilters) {
          id
          ... on RnPRole {
            id
          }
        }
      }
    }
  }
`;
